import { render, staticRenderFns } from "./SingleProject.vue?vue&type=template&id=e2b37062&"
import script from "./SingleProject.vue?vue&type=script&lang=js&"
export * from "./SingleProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports